import React, {
  CSSProperties, FC, PropsWithChildren, useMemo,
} from 'react';

import { SurfaceBase } from '../surface-base';
import {
  SurfaceType, ISurfaceProps,
} from './types';
import { useTypeStyles } from './styles';
import { Appearance } from '../surface-base/types';

export const Surface: FC<PropsWithChildren<ISurfaceProps>> = (props: ISurfaceProps) => {
  const {
    children, type, backgroundImage,
  } = props;
  const classesType = useTypeStyles();

  // assign type styles
  const typeClass = classesType[type as SurfaceType];

  const customStyles: CSSProperties = useMemo(() => {
    if (type === 'image-banner') {
      return {
        backgroundImage: `url("${backgroundImage}")`,
        backgroundSize: 'cover',
      };
    }
    return {};
  }, [backgroundImage, type]);

  const appearance: Appearance | undefined = useMemo(() => {
    switch (type) {
      case 'page':
      case 'page-centered':
        return 'default';

      case 'table':
      case 'main-form':
      case 'main-dashboard':
        return 'elevated';

      case 'support-main':
        return 'filled';

      case 'image-banner':
        return undefined;

      default: return 'default';
    }
  }, [type]);

  return (
    <SurfaceBase
      appearance={appearance}
      classNames={type && [typeClass]}
      styles={customStyles}
    >
      {children && children}
    </SurfaceBase>
  );
};

// Export Surface component
Surface.displayName = 'Surface';
